<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="性别" 
    isDisable="{{isSexDisable}}"
    innerValue="{{showValue}}"
  >
    <view class="es-content__gender" slot="input">
      <view class="gender-item" bindtap="selectGender('M')">
        <radio-circle size="{{18}}" checked="{{innerValue == 'M'}}" />
        <text class="gender-text">男</text>
      </view>
      <view class="gender-item" bindtap="selectGender('F')">
        <radio-circle size="{{18}}" checked="{{innerValue == 'F'}}" />
        <text class="gender-text">女</text>
      </view>
    </view>
  </from-item>
</template>

<script>
import { watch } from "@mpxjs/core";
  import { hasRequired } from '@/utils'
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    classes: [],
    data: {
      showValue: '',
      innerValue:''
    },
    props: {
      value:{
        type: String,
        value: ''
      },
      isRequiredShow: {
        type: Boolean,
        value: false
      },
      isShow: {
        type: Boolean,
        value: false
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
      isSexDisable: {
        type: Boolean,
        value: false
      }
    },
    computed: {
      isRequired() {
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      }
    },
    methods: {
      // 选择性别
      selectGender(e) {
        this.innerValue = e
      },
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.showValue = newValue === 'M' ? '男': '女'
        this.$trigger( 'input', {value:newValue} )
      },
    },
    mounted() {
      this.innerValue = this.value
    }
  })
</script>

<style lang='stylus' scoped>
  +b('content')
    +e('gender')
      display flex
      align-items center
      color #333333
      .gender-item
        margin-right 24px
        display flex
        align-items center
      .gender-text
        margin-left 8px
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'radio-circle': '../../radio-circle',
      'from-item': './from-item'
    }
  }
</script>

